import {
  MANAGE_REPLACE_START,
  MANAGE_RESET,
  MANAGE_RETIRE_START,
  MANAGE_REPROVISION_DEVICE_START,
  MANAGE_ENABLE_FAT_START,
  MANAGE_ENABLE_OAT_START,
  MANAGE_PROVISION_START,
  MANAGE_IDENTIFICATION_START,
  MANAGE_DISCOVERY_START,
  MANAGE_SCALE2_TARE_START,
  MANAGE_SCALE2_CALIBRATE_START,
  MANAGE_SCALE2_DISCOVERY_START,
  SET_RETIRE_REASON,
} from '../constants/actionTypes';

export const startReplacement = () => ({
  type: MANAGE_REPLACE_START,
});

export const startRetire = () => ({
  type: MANAGE_RETIRE_START,
});

export const setRetireReason = retiredReason => ({
  type: SET_RETIRE_REASON,
  retiredReason,
});
export const returnToMenu = () => ({
  type: MANAGE_RESET,
});

export const startReprovisionDevice = () => ({
  type: MANAGE_REPROVISION_DEVICE_START,
});

export const startEnableFAT = () => ({
  type: MANAGE_ENABLE_FAT_START,
});

export const startEnableOAT = () => ({
  type: MANAGE_ENABLE_OAT_START,
});

export const startProvision = () => ({
  type: MANAGE_PROVISION_START,
});

export const startIdentification = () => ({
  type: MANAGE_IDENTIFICATION_START,
});

export const startDiscovery = () => ({
  type: MANAGE_DISCOVERY_START,
});

export const startScale2Tare = () => ({
  type: MANAGE_SCALE2_TARE_START,
});

export const startScale2Calibrate = () => ({
  type: MANAGE_SCALE2_CALIBRATE_START,
});

export const startScale2Discovery = () => ({
  type: MANAGE_SCALE2_DISCOVERY_START,
});
